import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { i18nReady } from './i18n'
import './styles/global.scss'

const container = document.getElementById('root')
if (!container) throw new Error('#root missing')

// No StrictMode: the render loop, AudioContext and pointer listeners are set up
// in an effect, and StrictMode's deliberate double mount would start two loops
// and two audio graphs on every run.
i18nReady.then(() => {
  createRoot(container).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  )
})
